import { Component, Inject, InjectionToken, PLATFORM_ID } from '@angular/core';
import { ButtonComponent } from '../../../shared/components/button/button.component';
import { ActivatedRoute, Router } from '@angular/router';
import { PaymentApiService } from '../../../services/API/apiPaymentService/payment-api.service';
import { RedirectManagerService } from '../../../services/state-management/redirect.service/redirect-manager.service';
import { TokenService } from '../../../services/state-management/token.service/token.service';
import { StorageService } from '../../../services/state-management/storage.service/storage.service';
import { LOCAL_STORAGE } from '../../../models/constant/constants';
import { UserProfileService } from '../../../services/API/user-profile.service/user-profile.service';
import { CurrencyPipe, isPlatformBrowser, Location, NgIf } from '@angular/common';

@Component({
  selector: 'app-payment-success',
  standalone: true,
  imports: [ButtonComponent, CurrencyPipe, NgIf],
  templateUrl: './payment-success.component.html',
  styleUrl: './payment-success.component.scss',
})
export class PaymentSuccessComponent {
  sessionId: string | null = null;
  stripeSubscriptionId: string | null = null;
  paymentData: any;
  isLoading = false;
  constructor(
    private route: ActivatedRoute,
    private apiPayment: PaymentApiService,
    private router: Router,
    private redirectService: RedirectManagerService,
    private tokenService: TokenService,
    private storageService: StorageService,
    private userProfileService:UserProfileService,
    private location:Location,
    @Inject(PLATFORM_ID) private platformId:InjectionToken<Object>,
  ) { }

  ngOnInit(): void {
    // Subscribe to query parameters
    this.route.queryParams.subscribe((params) => {
      this.sessionId = params['session_id'] || null;
      this.stripeSubscriptionId = params['stripeSubscriptionId'] || null;

      if (this.sessionId) {
        this.paymentStatus();
      }
      if(this.stripeSubscriptionId) {
        this.subscribePrefilledForm()
      }
    });
  }

  subscribePrefilledForm(): void {
    this.isLoading = true;
    this.apiPayment
      .subscribeWithCard(this.stripeSubscriptionId as string)
      .subscribe({
        next: (res) => {
          this.paymentData = res.data;
          this.paymentData.paymentTime = this.paymentData.paymentTime * 1000; 
          
          const isStoragePersistant = this.storageService.getPersistentSignedIn();
          if (!isStoragePersistant) {
            this.tokenService.setToken(LOCAL_STORAGE.TOKEN, res.data.authToken, isStoragePersistant);
            this.setUserDetails();
          }
          this.isLoading = false;
        },
      });
  }

  paymentStatus() {
    this.isLoading = true;
    this.apiPayment.paymentStatus(this.sessionId).subscribe({
      next: (res) => {
        this.paymentData = res.data;
        const isStoragePersistant = this.storageService.getPersistentSignedIn();
        if (!isStoragePersistant) {
          this.tokenService.setToken(LOCAL_STORAGE.TOKEN, res.data.authToken, isStoragePersistant);
          this.setUserDetails();
        }
      },
      error: (err) => {
        console.log(err);
      },
      complete: () => { this.isLoading = false; }
    });
  }

  setUserDetails():void {
    this.userProfileService.getUserProfileDetail()
    .subscribe({
      next:(res) => {
        this.tokenService.setToken(LOCAL_STORAGE.USER_DETAILS, JSON.stringify(res.data), false);
      }
    })
  }

  convertToLocalTime() {
    if (this.paymentData && this.paymentData.paymentTime) {
      const timestamp = Number(this.paymentData.paymentTime);
      if (!isNaN(timestamp)) {
        const date = new Date(timestamp);
        return date.toLocaleString();
      }
    }
    return 'Invalid Date';
  }


  back() {
    const url = this.redirectService.getRoute('onSubscribe');
    if (url)
      this.router.navigateByUrl(url, { replaceUrl: true });
    else
      this.router.navigateByUrl('/gallery/explore', { replaceUrl: true });
  }
}
